import { useEffect, useState } from 'react';
import { MintSetupWizard, MintDashboard } from '@/components/mint/MintDashboard';
import { isMintSetupComplete, getMintConfig } from '@/lib/storage/mint-store';

export default function MintPage() {
  const [ready, setReady] = useState<boolean | null>(null);

  useEffect(() => {
    isMintSetupComplete().then(setReady);
  }, []);

  if (ready === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!ready) {
    return <MintSetupWizard />;
  }

  return <MintDashboard />;
}
